import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import InputBase from '@material-ui/core/InputBase'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/Search'
import BackspaceIcon from '@material-ui/icons/Backspace'
import { trackEvent } from '../../../../helpers/analytics'
import { trackWidgetClick } from '../../../../helpers/trackWidgetClick'
import {
  updateSearchQuery,
  updateSearchBarContents,
  showSearchBarContents,
} from '../../../apps/appSlice'
// import {
//   setSearchValue,
//   setSelectedRoutes,
//   setSelectedStops,
// } from '../../../maps/sections/Map/redux/myMapsSlice'
// import { setSelectedCampusBuildings } from '../../../maps/sections/Buildings/redux/myBuildingsSlice'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}))

export default function CustomizedInputBase({
  placeholder,
  value,
  onChange,
  onRequestSearch,
  onCancelSearch,
  webViewMode,
  moduleName,
  widgetId,
  dispatch,
}) {
  const classes = useStyles()
  // const route = window.location.pathname
  const searchTimer = React.useRef(null)

  // const trackSearchSubmit = (trigger) => {
  //   trackEvent(dispatch, {
  //     eventName: 'uxp_search_submit',
  //     module: 'UXP Shell',
  //     object: 'SearchBar',
  //     objectId: moduleName || 'SearchBar',
  //     action: 'Search',
  //     actionContext: trigger,
  //     actionContextValue: value ? 'SearchValueEntered' : 'EmptySearch',
  //     page: 'Shell',
  //     route,
  //     url: route,
  //     rcpid: localStorage.getItem('rutgersEduRCPID'),
  //     backendEvent: {
  //       module: 'SearchBar',
  //       object: 'SearchInput',
  //       objectId: moduleName || 'SearchBar',
  //       action: 'Search',
  //       actionContext: trigger,
  //       actionContextValue: value ? 'SearchValueEntered' : 'EmptySearch',
  //       rcpid: localStorage.getItem('rutgersEduRCPID'),
  //       url: route,
  //       timestamp: Date.now(),
  //     },
  //   })
  // }

  // const trackSearchClear = () => {
  //   trackEvent(dispatch, {
  //     eventName: 'uxp_search_clear',
  //     module: 'UXP Shell',
  //     object: 'SearchBar',
  //     objectId: moduleName || 'SearchBar',
  //     action: 'Clear',
  //     actionContext: 'ClearSearch',
  //     actionContextValue: value ? 'HadSearchValue' : 'EmptySearch',
  //     page: 'Shell',
  //     route,
  //     url: route,
  //     rcpid: localStorage.getItem('rutgersEduRCPID'),
  //     backendEvent: {
  //       module: 'SearchBar',
  //       object: 'SearchInput',
  //       objectId: moduleName || 'SearchBar',
  //       action: 'Clear',
  //       actionContext: 'ClearSearch',
  //       actionContextValue: value ? 'HadSearchValue' : 'EmptySearch',
  //       rcpid: localStorage.getItem('rutgersEduRCPID'),
  //       url: route,
  //       timestamp: Date.now(),
  //     },
  //   })
  // }

  // const handleRequestSearch = () => {
  //   trackSearchSubmit('SearchButton')
  //   onRequestSearch()
  // }

  // const handleClearSearch = () => {
  //   trackSearchClear()
  //   onCancelSearch()
  // }

  const handleRequestSearch = () => {
    trackWidgetClick(
      dispatch,
      widgetId || 'SearchBar',
      moduleName || placeholder || 'Search',
      { widgetId },
    )
    onRequestSearch()
  }

  const handleClearSearch = () => {
    trackWidgetClick(
      dispatch,
      widgetId || 'SearchBar',
      `Clear ${moduleName || placeholder || 'Search'}`,
      { widgetId },
    )
    onCancelSearch()
  }

  const handleSearchChange = (e) => {
    onChange(e)

    const searchValue = e.target.value

    if (searchTimer.current) {
      clearTimeout(searchTimer.current)
    }
    if (searchValue && searchValue.trim().length > 0) {
      searchTimer.current = setTimeout(() => {
        trackEvent(dispatch, {
          eventName: 'uxp_dashboard_widget_search',
          module: 'Dashboard',
          object: 'Widget',
          action: 'Search',
          actionContext: 'WidgetSearch',
          actionContextValue: moduleName || placeholder || 'WidgetNameNotFound',
        })
      }, 1000)
    }
  }
  return (
    <Paper component="form" className={classes.root} variant="outlined">
      <InputBase
        className={classes.input}
        placeholder={placeholder}
        value={value}
        onChange={handleSearchChange}
        onKeyPress={(e) => {
          if (e.key === 'Enter' && webViewMode) {
            onRequestSearch()
            e.preventDefault()
          } else if (e.key === 'Enter') {
            e.preventDefault()
          }
        }}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            if (moduleName === 'myApps') {
              dispatch(updateSearchQuery(''))
              dispatch(updateSearchBarContents([]))
              dispatch(showSearchBarContents(false))
            }
            if (moduleName === 'myMaps') {
              onCancelSearch()
            }
          }
        }}
        inputProps={{ 'aria-label': 'search' }}
      />
      <Divider className={classes.divider} orientation="vertical" />
      {value === '' ? (
        <IconButton
          onClick={handleRequestSearch}
          className={classes.iconButton}
          aria-label="search"
        >
          <SearchIcon />
        </IconButton>
      ) : (
        <IconButton
          onClick={handleClearSearch}
          className={classes.iconButton}
          aria-label="search"
        >
          <BackspaceIcon />
        </IconButton>
      )}
    </Paper>
  )
}
